import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";

const api = new APIClient();

const RESOURCE = "/notifications";

export interface AppNotificationData {
  kind?: string;
  title?: string;
  body?: string;
  title_key?: string;
  body_key?: string;
  action_url?: string;
  category?: string;
  product_count?: number;
  [key: string]: unknown;
}

export interface AppNotification {
  id: string;
  type: string;
  data: AppNotificationData;
  read_at: string | null;
  created_at: string;
}

export interface NotificationListParams extends PaginationParams {}

export const isNotificationUnread = (notification: AppNotification): boolean =>
  notification.read_at === null;

export const listNotifications = (
  params?: NotificationListParams
): Promise<PaginatedApiResponse<AppNotification>> =>
  api.get<PaginatedApiResponse<AppNotification>>(RESOURCE, params);

export const markNotificationAsRead = (
  id: string
): Promise<ApiResponse<AppNotification>> =>
  api.update<ApiResponse<AppNotification>>(`${RESOURCE}/${id}/read`, {});

export const markAllNotificationsAsRead = (): Promise<
  ApiResponse<{ updated_count: number }>
> => api.update<ApiResponse<{ updated_count: number }>>(`${RESOURCE}/read-all`, {});
